import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type HeaderProps = ComponentProps<'header'>;

export function Header({ className, ...props }: HeaderProps) {
  return (
    <header
      className={twMerge(
        'max-w-content-w h-nav-bar-height flex flex-1 items-center justify-between py-5 lg:px-10',
        className,
      )}
      {...props}
    />
  );
}
